var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultFootball(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24x24px/Result_default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "sport-recreation-football-activity-ball-svgrepo-com-(3)",
    transform: "translate(5.000000, 14.000000)",
    fill: "#333333",
    fillRule: "nonzero",
    stroke: "#333333",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 C1.79085714,0 0,1.79561481 0,4.01058818 C0.210693333,9.33056274 7.79012,9.32905209 8,4.01056717 C8,1.79561481 6.20914286,0 4,0 Z M4.2501219,1.06878566 L5.07572381,0.672613834 C5.78223744,0.903730885 6.3973829,1.35367295 6.8326,1.95766358 L6.70497272,2.88178621 L5.32694179,3.30309254 L4.24387734,2.4030802 L4.2501219,1.06878566 Z M3.7501219,1.06876123 L3.74274875,2.43298212 L2.59886457,3.25677981 L1.25039665,2.85897731 L1.1674381,1.95761966 C1.60263836,1.35362105 2.21779238,0.90368858 2.92431619,0.672613834 L3.7501219,1.06876123 Z M1.17764952,6.07728247 C0.736590742,5.4772376 0.499153627,4.75115151 0.500232602,4.00575447 L1.17764952,3.3680241 L2.46151967,3.73321731 L2.87504143,5.08578601 L2.06173098,6.23557337 L1.17764952,6.07728247 Z M5.08670667,7.3445042 C4.40844381,7.5763372 3.59146857,7.57629709 2.91320381,7.34448319 L2.48792503,6.55527429 L3.31055216,5.40140704 L4.60612577,5.378056 L5.52432303,6.55527429 L5.08670667,7.3445042 Z M5.92794925,6.25726776 L4.99061589,5.07031379 L5.469894,3.76634037 L6.78595257,3.36398089 L7.49975994,4.00579457 C7.50084799,4.75119296 7.26339481,5.47727862 6.82230667,6.07730347 L5.92794925,6.25726776 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#333333",
    fillRule: "nonzero",
    x: 7,
    y: 11.2,
    width: 11,
    height: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#333333",
    strokeWidth: 1.75,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    points: "2.5 15.7084166 2.5 14.3430043 2.5 2.5 21.4379858 2.5 21.4379858 15.8489042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.62,15 L3.33787762,15 L3.33787762,16.9550173 C3.29145964,17.321551 3.1291746,17.5048178 2.85102251,17.5048178 C2.43379436,17.5048178 2.52928165,17.5048178 2.1246056,17.5048178 C1.85482156,17.5048178 1.6866197,17.3215289 1.62,16.9549512 L1.62,15 Z",
    id: "Rectangle",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.56,14.5 L22.31,14.5 L22.31,16.9501995 C22.2627141,17.3167332 22.0973945,17.5 21.8140412,17.5 C21.3890114,17.5 21.4862842,17.5 21.0740412,17.5 C20.7992125,17.5 20.6278654,17.3167111 20.56,16.9501334 L20.56,14.5 Z",
    id: "Rectangle",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85686204,11.7 C3.36631672,11.677072 3.91341394,11.822699 4.49815371,12.1368812 C5.08289348,12.4510633 6.0061221,14.0391302 7.26783958,16.9010819",
    id: "Line-7",
    stroke: "#333333",
    strokeLinecap: "round",
    transform: "translate(5.062351, 14.299371) scale(-1, 1) translate(-5.062351, -14.299371) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8905353,11.7 C17.3130672,11.7 17.7624738,11.8 18.238755,12 C18.7150363,12.2 19.6450312,13.8185174 21.0287399,16.8555523",
    id: "Line-7",
    stroke: "#333333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4379858,12.2 C21.2390877,9.7138411 20.9798055,8.16407649 20.5167833,6.74918444 C20.0491229,5.32011931 19.316858,3.8349069 18.3139653,2.51313913 L17.5243332,3.12457582 C18.4411616,4.33291477 19.1236427,5.72138243 19.5444453,7.00726092 C19.9698861,8.30731249 20.4620901,11.2720371 20.4620901,12.2 L21.4379858,12.2 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(19.481160, 7.356570) scale(-1, 1) translate(-19.481160, -7.356570) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45415667,12.2 C6.25525849,9.7138411 6.00131568,8.16407649 5.53829343,6.74918444 C5.07063305,5.32011931 4.33836815,3.8349069 3.33547546,2.51313913 L2.54584333,3.12457582 C3.46267178,4.33291477 4.1451528,5.72138243 4.56595548,7.00726092 C4.99139628,8.30731249 5.47826087,11.2720371 5.47826087,12.2 L6.45415667,12.2 Z",
    id: "Path",
    fill: "#333333",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultFootball);
export default __webpack_public_path__ + "static/media/result_football.907f62f503e877c17093fc7efca446d1.svg";
export { ForwardRef as ReactComponent };